export default {
  recentNews: [
      {
   imgUrl:
    'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610417333.jpg',
    title: '懒熊体育创始人韩牧：产业5年发展的5点观察，不断进化才能蓄势而上',
    link: 'http://lanxiongsports.com/posts/view/id/20380.html',
     },
    {
      imgUrl:
        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610457620.jpg',
       title: '三大奖项18位获奖者，2020这些体育产业经典案例值得借鉴',
        link: 'http://lanxiongsports.com/posts/view/id/20381.html',
      },
    {
      imgUrl:
        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610449938.JPG',
      title: '吴克群、鲍春来、MLB中国在一起聊了聊体育+娱乐',
      link:
        'http://lanxiongsports.com/posts/view/id/20405.html',
    },
   // { 
   //   imgUrl:
   //   'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610440981.JPG',
   // title: '体育·新城市：城市更新，体育发挥重要作用',
   //  link: 'http://lanxiongsports.com/posts/view/id/20375.html',
  // },
  //    {
  //  imgUrl:
  //    'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610417333.jpg',
  //   title: '懒熊体育创始人韩牧：产业5年发展的5点观察，不断进化才能蓄势而上',
  //   link: 'http://lanxiongsports.com/posts/view/id/20380.html',
  // },

  //  {
  //    imgUrl:
  //      'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610432781.JPG',
  //    title: '体育·新消费：零售业就是“泥水中摸爬滚打”，要用长远眼光做眼前生意',
 //     link:
 //       'http://lanxiongsports.com/posts/view/id/20373.html',
 //   },
   // {
   //   imgUrl:
   //     'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610425916.jpg',
   //   title: '体育·新内容：疫情撕去最后面纱，版权市场将迎来健康发展',
   //   link:
  //      'http://lanxiongsports.com/posts/view/id/20372.html',
  //  },

//    {
//      imgUrl:
//        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610424279.jpg',
//      title: '体育·新趋势：2020体育产业已然触底，未来体育公司需增强抵御风险能力',
//      link: 'http://lanxiongsports.com/posts/view/id/20371.html',
//    },
//    {
//      imgUrl:
//        'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610417333.jpg',
//      title: '懒熊体育创始人韩牧：体育产业五年发展“喜忧参半”，不断进化才能“蓄势而上”',
//     link: 'http://lanxiongsports.com/posts/view/id/20370.html',
//   },
//   {
//     imgUrl:
//      'http://imgcdn.lanxiongsports.com/uploads/2021/01/12/1610440981.JPG',
//     title: '体育·新城市：城市更新，体育发挥重要作用',
//     link: 'http://lanxiongsports.com/posts/view/id/20375.html',
//   },

  ],
  album: [
    {
      imgUrl:
        'http://imgcdn.lanxiongsports.com/jnh20/album/YB22776_w66682.jpg',
      title: '第五届体育产业嘉年华现场',
      link:
        'https://live.photoplus.cn/live/pc/56912780/#/live',
    },

    {
      imgUrl:
        'http://imgcdn.lanxiongsports.com/jnh20/album/800A5211_w18352.jpg',
      title: '懒熊特步联名产品发布',
      link:
        'https://live.photoplus.cn/live/pc/56912780/#/live',
    },
//    {
//      imgUrl:
//        'https://imgcdn.lanxiongsports.com/jnh20/album/WEN2521_w3311.jpg',
//      title: '体育·新消费：双循环下再升级',
//      link:
//        'https://live.photoplus.cn/live/pc/56912780/#/live',
//    },
//    {
//      imgUrl:
//        'https://imgcdn.lanxiongsports.com/jnh20/album/WEN2418_w8580.jpg',
//     title: '体育·新内容：理性与感性',
//      link:
//        'https://live.photoplus.cn/live/pc/56912780/#/live',
//    },
    {
      imgUrl:
        'http://imgcdn.lanxiongsports.com/uploads/2021/01/10/1610262517.jpg',
      title: '第五届体育产业嘉年华|嘉宾金句合集',
      link:
        'http://lanxiongsports.com/posts/view/id/20358.html',
    },
  ],
  videosList: [
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/carnival_vid_cover.jpeg',
      title: '“赶路的人”首届体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/upload/carnival/news3.jpg',
      title: '“潮前走”第二届中国体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
    {
      imgUrl: 'http://imgcdn.lanxiongsports.com/upload/carnival/news4.png',
      title: '“赶路的人”首届体育产业嘉年华回顾',
      link: 'http://www.lanxiongsports.com/posts/view/id/4941.html',
    },
  ],
};
